import React, { Component } from "react";
import {showAxiosError} from "../helper/helper";

class DraggerUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dragActive: false,
            files: [],
        };
        this.inputRef = React.createRef();
    }

    handleDrag = (e) => {
        if (this.props.disabled) return;
        e.preventDefault();
        e.stopPropagation();
        if (e.type === 'dragenter' || e.type === 'dragover') {
            this.setState({ dragActive: true });
        } else if (e.type === 'dragleave') {
            this.setState({ dragActive: false });
        }
    };

    handleDrop = (e) => {
        if (this.props.disabled) return;
        e.preventDefault();
        e.stopPropagation();
        this.setState({ dragActive: false });
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            this.handleFiles(e.dataTransfer.files);
        }
    };

    handleFiles = (eFiles) => {
        const files = [...this.state.files];
        files.push(...eFiles);
        this.setState({files});
    };

    uploadFiles() {
        const {files} = this.state;
        if (files.length === 0) {
            showAxiosError({message: "Lütfen bir dosya seçin."});
            return;
        }

        this.props.uploadFiles(files, this.props.type)
            .then(() => {
                this.setState({files: []});
            }).catch(error => {
            //showAxiosError({message: "Dosya yükleme hatası."});
        });
    }

    render() {
        const { dragActive, files } = this.state;
        const { disabled } = this.props;

        return (
            <div style={this.props.style}
                className={`drag-drop-area ${dragActive ? 'drag-active' : ''} ${disabled ? 'disabled' : ''}`}
                onDragEnter={this.handleDrag}
                onDragLeave={this.handleDrag}
                onDragOver={this.handleDrag}
                onDrop={this.handleDrop}
            >
                <input
                    type="file"
                    ref={this.inputRef}
                    multiple
                    onChange={(e) => this.handleFiles(e.target.files)}
                    style={{ display: 'none' }}
                />
                <p>Dosyayı buraya sürükleyip bırakın veya </p>
                <button
                    className="drag-drop-area-button"
                    onClick={() => this.inputRef.current.click()}
                    disabled={disabled}
                    style={{ width: '100%', maxWidth: '200px' }}
                >
                    Dosya Seç
                </button>
                {files.length > 0 && (
                    <div>
                        <h4>Seçilen Dosyalar:</h4>
                        <ul>
                            {files.map((file, index) => (
                                <li key={index}>{file.name}</li>
                            ))}
                        </ul>
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => this.uploadFiles()}
                        >
                            Dosya Yükle
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default DraggerUpload;